/**
 * The mobile app menu entries that can be renamed/hidden from here.
 *
 * Mirrors the entries carrying a `configKey` in
 * mobileApp/utils/menuDrawerItems.ts, which is the source of truth for the app.
 * Kept duplicated because backofficeweb and mobileApp are separate npm
 * projects (same as IConfigs, already duplicated in both).
 *
 * `defaultLabel` is only shown as a placeholder so the editor can see what the
 * entry says today; leaving the field empty makes the app use its own default.
 */
export interface IMenuEntryDefinition {
  configKey: string;
  defaultLabel: string;
}

export const MENU_ENTRIES: IMenuEntryDefinition[] = [
  { configKey: 'sessions', defaultLabel: 'Sesiones' },
  { configKey: 'speakers', defaultLabel: 'Disertantes' },
  { configKey: 'grid', defaultLabel: 'Grilla Horaria' },
  { configKey: 'rockstars', defaultLabel: 'Disertantes Destacados' },
  { configKey: 'now', defaultLabel: 'Sesiones en curso / próximas' },
  { configKey: 'infoList', defaultLabel: 'Información general' },
  { configKey: 'favoritos', defaultLabel: 'Mis Favoritos' },
  { configKey: 'notas', defaultLabel: 'Mis Notas' },
  { configKey: 'notifications', defaultLabel: 'Notificaciones' },
  { configKey: 'lineaNeurologia', defaultLabel: 'Línea Neurología' },
  { configKey: 'lineaPsiquiatria', defaultLabel: 'Línea Psiquiatría' },
  { configKey: 'floorPlan', defaultLabel: 'Planos' },
  { configKey: 'sponsoredSessions', defaultLabel: 'Sesiones Patrocinadas' },
];
